const types = {
    login: 'LOGIN',
    logout: 'LOGOUT',

    // errores en la interfaz de usuario
    uiSetError: 'UISETERROR',
    uiRemoveError: 'UIREMOVEERROR',

    registerDB: 'Subir api a firebase',
    listMovies: 'Listar peliculas de firebase',
    newMovie: 'Agregar una nueva pelicula',
    deleteMovie: 'Eliminar pelicula',
    editMovie: 'Editar pelicula',
    searchMovie: 'buscar peli',
    searchMovieSave: 'Bucar pelicula guardada',
    listMoviesSave: 'Listar las peliculas guardadas'
}
export default  types
